module.exports = __webpack_public_path__ + "static/media/anc4ru.7b335ba6.pdf";